import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRectangleLandscape } from '@fortawesome/pro-regular-svg-icons/faRectangleLandscape'

export const defaultTranslations = {
    pluginName: 'Product Comparison',
    pluginDescription: 'Product Comparison Table',
}

export const defaultSettings = {
    Controls: () => <>Controls for this plugin were not provided</>,
    Renderer: () => <>Renderer for this plugin was not provided</>,
    translations: defaultTranslations,
    IconComponent: <FontAwesomeIcon icon={faRectangleLandscape} size="3x" />,
}
